import { setAllBrandsAct } from './brands'
import { setAllDelegationsAct } from './delegations'
import { setAllCompaniesAct } from './companies'
import apiAccount from 'api/account'
import operator from 'api/operator'
import { SET_CHATWEB_AUTH_TOKEN, SET_USER_DATA, SET_USER_AVAILABLE } from '../reducers/user'
import { SET_SIDEBAR_ITEMS } from '../reducers/sidebar'
import { modulesAct } from '../actions'
import dkvConfiguration from 'constants/dkv.constants'
import i18nActions from './i18nActions'
import { getMnemonics } from 'redux/mnemonics/actions'
import { setNotifications } from 'redux/currentNotifications/actions'

import Grafana from 'services/Grafana'
import NotificationsService from 'services/NotificationsService'
import poolListsAct from '../poolLists/actions'
import settingsAct from '../settings/actions'
import operatorDisabledAct from '../operatorAutoDisabled/actions'
import rolePermissionsActions from '../rolePermissions/actions'
import CurrentPlanActions from '../currentPlan/actions'

const operatorApi = operator.operators

// If we get an auth token for chatweb, this action stores it
export const setChatwebAuthToken = (chatwebAuthToken = '') => ({
  chatwebAuthToken,
  type: SET_CHATWEB_AUTH_TOKEN,
})

// Store the user data in the reducer
export const setUserData = (user) => ({ user, type: SET_USER_DATA })

// Store Sidebar's items
export const setSideBarData = (sidebar) => ({ sidebar, type: SET_SIDEBAR_ITEMS })

// Logout action
export const logout = () => async (dispatch, getState) => {
  try {
    const { user } = getState()

    if (user.authToken) {
      sessionStorage.removeItem(dkvConfiguration.sessionStorage)
      await apiAccount.logout()

      NotificationsService.remove()
    }
  } catch (error) {
    console.error(error)
  }

  dispatch({ type: 'USER_LOGOUT' })
}

// Given an auth token, it gets the data related to the logged in user and stores it
const getOperator = (authToken, firstLogin = false, queryParams) => async (dispatch) => {
  try {
    if (!authToken) {
      await i18nActions.updateText({})(dispatch)

      dispatch({ type: 'USER_LOGOUT' })

      return true
    }

    await Grafana.oauthRedirect(queryParams, authToken)

    const { data } = await apiAccount.getOperator(authToken)
    const { operator, brands, delegations, company, sidebar, withLists } = data
    operator.authToken = authToken

    await i18nActions.updateText({
      locale: operator.locale,
      company: operator.company,
      type: operator.companyType,
    })(dispatch)
    await dispatch(settingsAct.get({}))

    dispatch(CurrentPlanActions.getCurrentPlan())
    dispatch(setAllBrandsAct(brands))
    dispatch(setAllDelegationsAct(delegations))
    dispatch(setAllCompaniesAct(company))
    dispatch(modulesAct.upsert(company.activationModules))
    dispatch(operatorDisabledAct.setOperatorDisabled(company.operatorAutoDisabled))
    dispatch(setSideBarData(sidebar))
    dispatch(setNotifications(operator.notifications))
    dispatch(rolePermissionsActions.getOperatorPermission())
    dispatch(
      setUserData({
        ...operator,
        firstLogin: firstLogin,
        allowedBrands: brands,
        allowedDelegations: delegations,
      })
    )
    dispatch(poolListsAct.event({ withLists }))
    dispatch(getMnemonics(operator._id))

    NotificationsService.checkPermission(operator.tokenFirebaseNotifications)

    return true
  } catch (error) {
    try {
      await i18nActions.updateText({})(dispatch)
    } catch (error) {
      console.error('t', error)
    }

    dispatch(logout())
    return false
  }
}

// This action updates the user related data
const updateOperator = (operator) => async (dispatch, oldState) => {
  const { i18n: { locale }, user } = oldState()
  const prevUser = { ...user }

  dispatch(setUserData(operator))
  operatorApi.updateOperator(operator)
    .catch(() => dispatch(setUserData(prevUser)))

  // Update dashboard translation content
  if (locale !== operator.locale) {
    await i18nActions.updateText({
      locale: operator.locale,
      company: operator.company,
      type: operator.companyType,
    })(dispatch)
  }
}

const setAvailable = (isAvailable) => async (dispatch, oldState) => {
  const { user } = oldState()

  let available = false
  try {
    available = user.available || false

    dispatch({ type: SET_USER_AVAILABLE, isAvailable: isAvailable })

    await operatorApi.available(isAvailable)
  } catch(error) {
    dispatch({ type: SET_USER_AVAILABLE, isAvailable: available })
  }
}

export default {
  setUserData,
  logout,
  getOperator,
  updateOperator,
  setAvailable
}
